import { render, staticRenderFns } from "./shopOrder.vue?vue&type=template&id=674740ca&scoped=true"
import script from "./shopOrder.vue?vue&type=script&lang=js"
export * from "./shopOrder.vue?vue&type=script&lang=js"
import style0 from "./shopOrder.vue?vue&type=style&index=0&id=674740ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674740ca",
  null
  
)

export default component.exports